export const UserGroupListTableBody = ({ currentPage, numberPerPage, items, handleEditClick, handleRemoveClick, loadingError, loading }) => {
    const begin = (Number(currentPage) - 1) * Number(numberPerPage);
    const end = begin + Number(numberPerPage);
    const data = items.slice(begin, end);

    if (loadingError)
        return (
            <tr>
                <td colSpan="4" className="table-danger text-center">
                    {loadingError}
                </td>
            </tr>
        );

    return data.length === 0
        ? !loading && (
              <tr>
                  <td colSpan="4" className="table-danger text-center">
                      No User Groups to display
                  </td>
              </tr>
          )
        : data.map(({ name, id }) => {
              return (
                  <tr key={id}>
                      <td>{name}</td>
                      <td className="text-end">
                          <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                  handleEditClick(id);
                              }}
                          >
                              <i className="fa fa-pencil" title="Edit"></i>
                          </button>

                          <button
                              type="button"
                              className="btn btn-sm btn-danger ms-1"
                              onClick={() => {
                                  handleRemoveClick(id);
                              }}
                          >
                              <i className="fa fa-trash" title="Remove"></i>
                          </button>
                      </td>
                  </tr>
              );
          });
};
